import { render, staticRenderFns } from "./PublicationModal.vue?vue&type=template&id=60201784&scoped=true&"
import script from "./PublicationModal.vue?vue&type=script&lang=js&"
export * from "./PublicationModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicationModal.vue?vue&type=style&index=0&id=60201784&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60201784",
  null
  
)

export default component.exports